import api from '../../services/service'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      code: this.getParam('code'),
      state: this.getParam('state'),
      home_number: '',
      token: '',
      zone_id: '',
      zone_data: []
    }
  },
  methods: {
    getToken() {
      this.$store.state.isLoading = true
      let obj = {
        grant_type: 'authorization_code',
        code: this.code,
        redirect_uri: 'https://village.extensionsoft.biz/regisline',
        client_id: 'dwF5xEz6Cjszs4FDCSrpt8',
        client_secret: this.$store.state.config.line_state
      }
      api.getTokenLine(
        obj,
        result => {
          if (result.response === true) {
            this.token = result.token
          } else {
            Swal.fire('ดึง token ', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    connect() {
      if (this.home_number !== '' && this.zone_id !== '') {
        this.$store.state.isLoading = true
        var obj = {
          home_number: this.home_number,
          zone_id: this.zone_id,
          token: this.token,
          state: this.state
        }
        api.regisLine(
          obj,
          result => {
            if (result.response === true) {
              Swal.fire('ลงทะเบียน', result.message, 'success')
              window.location = '/'
            } else {
              Swal.fire('ลงทะเบียน', result.message, 'warning')
            }
            this.$store.state.isLoading = false
          },
          error => {
            alert(JSON.stringify(error))
            this.$store.state.isLoading = false
          }
        )
      } else {
        Swal.fire('ลงทะเบียน', 'กรุณากรอกข้อมูลให้ครบถ้วน', 'warning')
      }
    },
    close() {
      window.open('', '_self', '')
      window.close()
    },
    getZone() {
      this.$store.state.isLoading = true
      api.getZoneAll(
        result => {
          if (result.response === true) {
            this.zone_data = result.data
            this.$store.state.isLoading = false
          } else {
            Swal.fire('ดึง zone ', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
  },
  mounted() {
    this.getZone()
    if (sessionStorage.config) {
      this.$store.state.config = JSON.parse(sessionStorage.config)
      this.getToken()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/regisline.js